define('SearchFilters/searchFilters',[
    "LearningLibrarySearchResults/learningLibrarySearchResults",
    "common/accordion",
    "common/urlUtils"    
],
    function (learningLibrarySearchResults, accordion, urlUtils) {   
        const urlParamSeparator = "|";
        const CHECKBOX_TYPE_TAG = "0";
        const CHECKBOX_TYPE_CONTENT_TYPE = "1";
        const CONTENT_TYPES_QUERY_STRING_KEY = "contenttypes"

    function init() {      
        setSelectedCheckboxesFromQueryString("tags");
        setSelectedCheckboxesFromQueryString(CONTENT_TYPES_QUERY_STRING_KEY);
        $(".facet-checkbox").off("click").on("click", executeSearch);
        $(".facet-clear").off("click").on("click", clearFacet);
        accordion.init(".search-filters");
    }

    function setSelectedCheckboxesFromQueryString(queryParam) {
        var selectedTagsQueryStringParam = urlUtils.getParamFromUrl(queryParam, window.location.href);
        if (selectedTagsQueryStringParam) {           
            var tags = selectedTagsQueryStringParam.split(urlParamSeparator);         
            for (var i = 0; i < tags.length; i++) {
                $("#" + tags[i]).prop("checked", true);               
            }          
        }
    }

    function clearFacet() {
        $(this).closest(".facet").find(".facet-checkbox").prop("checked", false);
        executeSearch();
    }

        function executeSearch() {           
            var checkedTags = "";
            var checkedContentTypes = "";
            var tagsInfo = [];
            $(".facet-checkbox:checkbox:checked").each(function () {
                var checkboxType = $(this).data("checkboxType");
                if (checkboxType == CHECKBOX_TYPE_TAG)
                    checkedTags += $(this).val() + urlParamSeparator;
                if (checkboxType == CHECKBOX_TYPE_CONTENT_TYPE)
                    checkedContentTypes += $(this).val() + urlParamSeparator;
                var label = $("#spantext_" + $(this).attr('id')).text();
                tagsInfo.push({ "TagId": $(this).val(), "TagGroupName": $(this).attr("title"), "TagText": label });
            });

            //if there are no category facets on page, set content types from query string if we have contenttype parameter
            if (!$(".content-type-container").length) {
                var contentTypesFromQueryParam = urlUtils.getParamFromUrl(CONTENT_TYPES_QUERY_STRING_KEY, window.location.href);
                if (contentTypesFromQueryParam)
                    checkedContentTypes = contentTypesFromQueryParam;
            }

            if (checkedTags.endsWith(urlParamSeparator))
                checkedTags = checkedTags.slice(0, -1);
            if (checkedContentTypes.endsWith(urlParamSeparator))
                checkedContentTypes = checkedContentTypes.slice(0, -1);

            learningLibrarySearchResults.getSearchResults(null, null, checkedTags, checkedContentTypes, 0, tagsInfo);
        }
    
    return {
        init : init        
    };    
});

